import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../assets/FCI Logo - Cropped.png';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('logout'); 

    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard');
    }

    const handleStorageChange = (event) => {
      if (event.key === 'token' && event.newValue) {
        navigate('/dashboard');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/authentication/login`, {
        username,
        password,
      });

      const {
        token,
        id,
        userName,
        email,
        phoneNumber,
        userType,
        supervisorName,
        staffLevel,
        signatureFilePath,
        displayPictureFilePath,
      } = response.data;

      localStorage.setItem('token', token);
      const decoded = jwtDecode(token);
      const fullNameFromToken = decoded?.FullName || 'Unknown User';
      localStorage.setItem('fullName', fullNameFromToken);

      localStorage.setItem('userId', id);
      localStorage.setItem('userName', userName);
      localStorage.setItem('email', email);
      localStorage.setItem('phoneNumber', phoneNumber);
      localStorage.setItem('userType', userType);
      localStorage.setItem('supervisorName', supervisorName);
      localStorage.setItem('staffLevel', staffLevel);
      localStorage.setItem('signatureFilePath', signatureFilePath);
      localStorage.setItem('displayPictureFilePath', displayPictureFilePath);

      navigate('/dashboard');
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message);
      setError('Sorry. Login failed. Please check your credentials or your network connection');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className={`login-box ${isLoading ? 'dimmed' : ''}`}>
        {/* Remove the spinning class from the main logo */}
        <img src={logo} alt="Logo" className="logo" />
        <h2 className="login-title">Requisition and Surrender System</h2>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        
        <form onSubmit={handleLogin}>
          <input
            type="text"
            className="login-input"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={isLoading}
          />
          <input
            type="password"
            className="login-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={isLoading}
          />
          <button className="login-button" disabled={isLoading}>
            {isLoading ? 'Please wait...' : 'Login'}
          </button>
          <p className="forgot-password">Forgot Password?</p>
        </form>

        {/* Overlay with spinner - only shows when loading */}
        {isLoading && (
          <div className="login-loader-overlay">
            <div className="spinning-logo-container">
              <div className="logging-text">Logging in...</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;